import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/test/form',
      name: 'test-form',
      component: () => import('./views/TestForm.vue')
    },
    {
      path: '/test/select/:testerID',
      name: 'test-select',
      component: () => import('./views/TestSelect.vue')
    },
    {
      path: '/test/quiz/:step/:testerID',
      name: 'test-quiz',
      component: () => import('./views/TestQuiz.vue')
    },
    {
      path: '/test/result/:testerID',
      name: 'test-result',
      component: () => import('./views/TestResult.vue')
    },
    {
      path: '/find',
      name: 'find',
      component: () => import('./views/Find.vue')
    },
    { 
      path: "/franchisee",
      name: 'franchisee',
      component: () => import('./views/Franchisee')
    },
    { 
      path: "/noticemain",
      name: 'noticemain',
      component: () => import('./views/Noticemain')
    },
    { 
      path: "*", 
      redirect: '/'
    }
  ]
})
